import axios from "axios";
/**
 * Validate if a frame rim can be delivered
 * @param sku SKU of the length
 * @param rebateSize Rebate size of the frame rim
 * @returns Delivery validation result (promise)
 */
export async function frameDelivery(sku, rebateSize) {
    const { data } = await axios.get('/api/validation/frame/delivery', {
        params: {
            sku,
            rebateWidth: rebateSize.width,
            rebateLength: rebateSize.length
        }
    });
    return data;
}
/**
 * Validate whether a sheet (cts) can be delivered
 * @param sku SKU of the sheet
 * @param size Size of the sheet
 * @param inFrame Whether the sheet is going in a frame
 * @returns Delivery validation result (promise)
 */
export async function sheetDelivery(sku, size, inFrame = false) {
    const { data } = await axios.get('/api/validation/sheets/delivery', {
        params: {
            sku,
            width: size.width,
            length: size.length,
            isInFrame: inFrame ? 1 : 0
        }
    });
    return data;
}
